package com.example.monetix.db

import kotlin.Boolean
import kotlin.Long
import kotlin.String

public data class AccountEntity(
  public val id: String,
  public val name: String,
  public val logoEmoji: String?,
  public val logoUri: String?,
  public val isVisible: Boolean,
  public val isHidden: Boolean,
  public val isSavings: Boolean,
  public val isArchived: Boolean,
  public val isDeleted: Boolean,
  public val createdAtEpochMs: Long,
  public val updatedAtEpochMs: Long,
)
